import { api } from '../services/api'

export const setUser = (user) => {
	return (dispatch) => {
		dispatch({
			type: 'SET_USER',
			payload: { user }
		})
	}
}

export const getUser = (user) => {
	return (dispatch) => {
		dispatch({ type: 'GET_USER' })
		
		return api
			.get(`/users/${user.uid}`)
			.then((response) => {

				dispatch({ type: 'GET_USER_SUCCESS', payload: response.data })
			})
			.catch(() => {

				dispatch({ type: 'GET_USER_FAIL' })
			})
	}
}

export default {
	setUser
}
